<template>
  <el-container>
    
    <el-aside width="250px">
      <div class="el-aside__logo"></div>
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#304156"
        text-color="#fff"
        @select="changeSidebar"
        active-text-color="#4980ff">

        <el-menu-item index="GeRen">
          <i class="el-icon-chat-dot-square"></i>
          <span slot="title">打卡记录查询</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>小鹅科技-学堡</el-header>
      <el-main>
        <!-- 核心在这，这里是路由的出口-->
        <router-view></router-view>
      </el-main>
      <!-- 底部区域 -->
      <el-footer>学堡 ©2025 Created by 小鹅科技</el-footer>
    </el-container>
  </el-container>
</template>

<script>

import axios from 'axios';

export default {
  data() {
    return {
      code: '',
      state: '',
    };
  },

  mounted() {
    this.handleRedirect();

  },
  methods: {
    

    handleRedirect() {
      this.code = this.$route.query.code;
      this.state = this.$route.query.state;
      console.log(this.code);

      if (this.code && this.state) {
        console.log('Code:', this.code);
        console.log('State:', this.state);

        // 可以在这里发送这些参数到后端
        axios.post('https://xbxy.xiao-e.tech/api/redirect', { code: this.code, state: this.state })
          .then(response => {
            console.log('Response:', response.data);
            console.log('response.data.data:', response.data.data);
            //将response.data.data存入cookie中，后续调用其他api要将这个authorization放在头部发送给前端
            const token = response.data.data;
            // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
            localStorage.setItem('token', token);
            const token1 = localStorage.getItem('token');
            console.log('token1', token1);
            this.getUserRole();
          })
          .catch(error => {
            console.error('Error:', error);
          });
      } else {
        console.error('Missing code or state parameter');
      }
    },

    changeSidebar(path) {
      // Check if the current path is different from the target path
      if (this.$route.path !== path) {
        this.$router.push(path); // Navigate to the new route
      }
    },
  }
};
</script>

<style scoped>
.el-aside__logo {
  height: 120px;
  background: url('@/assets/logo1.png') no-repeat center / 120px auto;
}
.el-container {
  height: 100vh; /* 使容器占满整个视口 */
}

.el-header {
  background-color: #fff;
  color: #333;
  font-size: 20px;
  text-align: left;
  line-height: 60px;
}

.el-aside {
  background-color: #304156;
  height: 100%; /* 侧边栏占据全部高度 */
}

.menu {
  height: 100%; /* 使菜单占据全部侧边栏高度 */
}

.el-main {
  background-color: #f7f8fa;
  color: #333;
  padding: 20px;
}
.el-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}
</style>